export class UtilDom {

    static element(id) {
        return document.getElementById(id);
    }

    static hide(id) {
        UtilDom.element(id).style.display = 'none';
    }

    static show(id) {
        UtilDom.element(id).style.display = 'block';
    }

    static get_bounds(id) {
        return UtilDom.element(id).getBoundingClientRect();
    }

    static deepCopy(inObject) {
        let outObject, value, key
        if (typeof inObject !== "object" || inObject === null) {
            return inObject // Return the value if inObject is not an object
        }
        // Create an array or object to hold the values
        outObject = Array.isArray(inObject) ? [] : {}
        for (key in inObject) {
            value = inObject[key]
            if (key === 'ref') {
                outObject[key] = value;
                continue;
            }
            // Recursively (deep) copy for nested objects, including arrays
            outObject[key] = this.deepCopy(value)
        }
        return outObject
    }

}

export default UtilDom;